import React, { useState, useEffect } from "react";
import {
    Tab,
    Tabs,
    Typography,
    CardMedia,
    Grid,
    Box,
} from "@material-ui/core";

import useStyles from "./styles";
import TopSpacer from "../../../components/Common/spacer/TopSpacer";
import Breadcrumbs from "../../../components/BreadCrums/breadcrums";
// import DetailPage from "./detailPage/DetailPage";
import CashDisbursement from "./disbursementDetails/cashDisbursement/CashDisbursement";
import InKindDisbursement from "./disbursementDetails/inKindDisbursement/InKindDisbursement";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function ProgramDetails({ ...props }) {
    const classes = useStyles();
    const [value, setValue] = useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <>
            <TopSpacer></TopSpacer>

            <div className={classes.header}>
                <Grid container alignItems="baseline">
                    <Grid item lg={12}>
                        <Breadcrumbs parentLink={"Disbursement"} isBack={true}></Breadcrumbs>
                    </Grid>
                </Grid>
            </div>
            <div className={classes.tabcontainer}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    centered
                    aria-label="full width tabs example"
                >
                    <Tab label="Cash Disbursement" {...a11yProps(0)} />
                    <Tab label="In-Kind Disbursement" {...a11yProps(1)} />
                </Tabs>

                <TabPanel value={value} index={0}>
                    <CashDisbursement></CashDisbursement>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <InKindDisbursement></InKindDisbursement>
                </TabPanel>

            </div>

        </>
    )
}

export default ProgramDetails;